import React, { useContext } from 'react';
import { Control, Controller } from 'react-hook-form';
import useStyles from '../useStyles';
import OutlinedTextField from '@routes/Common/OutlinedTextField';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { MyAccountContext } from '@routes/MyAccount/MyAccountContainer';

interface Props {
  onSubmit: () => void;
  control: Control<{
    email: string;
    password: string;
  }>;
}
const ConfirmPasswordPresenter = ({ onSubmit, control }: Props) => {
  const classes = useStyles();
  const context = useContext(MyAccountContext);

  return (
    <div className={classes['Member-Withdrawal-ConfirmPassword-root']}>
      <div className="input-root">
        <CustomizedTypography
          variant="body1"
          color="textPrimary"
          gutterBottoms={8}
        >
          이메일*
        </CustomizedTypography>
        <Controller
          name="email"
          defaultValue={context.DecodedaccessTokenEmail ?? ''}
          control={control}
          render={(renderProps) => (
            <OutlinedTextField
              disabled
              fullWidth
              size="large"
              align="left"
              InputProps={{
                readOnly: true
              }}
              {...renderProps}
            />
          )}
        />
      </div>

      <div className="input-root">
        <CustomizedTypography
          variant="body1"
          color="textPrimary"
          gutterBottoms={8}
        >
          비밀번호*
        </CustomizedTypography>
        <Controller
          name="password"
          defaultValue=""
          control={control}
          rules={{
            required: {
              value: true,
              message: '비밀번호를 입력해 주세요.'
            }
          }}
          render={(renderProps) => (
            <OutlinedTextField
              size="large"
              align="left"
              placeholder="비밀번호"
              fullWidth
              InputProps={{
                type: 'password'
              }}
              {...renderProps}
            />
          )}
        />
      </div>

      <CustomizedButton
        fullWidth
        size="large"
        variant="contained"
        color="primary"
        onClick={onSubmit}
      >
        비밀번호 확인
      </CustomizedButton>
    </div>
  );
};

export default ConfirmPasswordPresenter;
